import { useReducer } from 'react';

import { createContainer } from 'react-tracked';

import RootReducers from './RootReducer';

const [RootReducer, initialState] = RootReducers();

export const { Provider: SharedStateProvider, useTracked: useSharedState } =
  createContainer(() => useReducer(RootReducer, initialState));
